import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useGenerateAccessTokenCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	generatedBy?: string | Ref<string> | (() => string), 
	secret?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _generatedBy = isRef<string>(generatedBy) ? generatedBy : ref<string>((typeof generatedBy === 'function') ? generatedBy() : generatedBy)
	const _secret = isRef<string>(secret) ? secret : ref<string>((typeof secret === 'function') ? secret() : secret)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		generatedBy: _generatedBy,
		secret: _secret,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof generatedBy === 'function') { _generatedBy.value = generatedBy() }
			if (typeof secret === 'function') { _secret.value = secret() }

			return new c.GenerateAccessTokenCommandV1(_id.value, _organizationUnitId.value, _generatedBy.value, _secret.value)
		})
	}

	return {
		...result,
		authorizedGenerateAccessTokenCommandV1: result.authorized,
		generateAccessTokenCommandV1: result.command,
		completedGenerateAccessTokenCommandV1: result.completed,
		errorGenerateAccessTokenCommandV1: result.error,
		invokeGenerateAccessTokenCommandV1: result.invoke,
		invokingGenerateAccessTokenCommandV1: result.invoking,
		succeedGenerateAccessTokenCommandV1: result.succeed,
		validationErrorsGenerateAccessTokenCommandV1: result.validationErrors,
		onSucceedGenerateAccessTokenCommandV1: result.onSucceed,
	}
}

export function useRevokeAccessTokenCommandV1(
	id?: string | Ref<string> | (() => string), 
	revokedBy?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _revokedBy = isRef<string>(revokedBy) ? revokedBy : ref<string>((typeof revokedBy === 'function') ? revokedBy() : revokedBy)

	const result = {
		id: _id,
		revokedBy: _revokedBy,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof revokedBy === 'function') { _revokedBy.value = revokedBy() }

			return new c.RevokeAccessTokenCommandV1(_id.value, _revokedBy.value)
		})
	}

	return {
		...result,
		authorizedRevokeAccessTokenCommandV1: result.authorized,
		revokeAccessTokenCommandV1: result.command,
		completedRevokeAccessTokenCommandV1: result.completed,
		errorRevokeAccessTokenCommandV1: result.error,
		invokeRevokeAccessTokenCommandV1: result.invoke,
		invokingRevokeAccessTokenCommandV1: result.invoking,
		succeedRevokeAccessTokenCommandV1: result.succeed,
		validationErrorsRevokeAccessTokenCommandV1: result.validationErrors,
		onSucceedRevokeAccessTokenCommandV1: result.onSucceed,
	}
}

